import React from "react";
import Circulations from "../modules/Circulations/Circulations";

export default function CirculationsPage() {
  return <Circulations />;
}
